import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import {
  getLanguageMessagesService
} from './languageSwitcherServiceMocks';
import { DvNotification } from "../../components/utility/dvGeneralUtilities";

function* languageMessagesRequest(action) {
  const { language } = action;
  const {languageId} = language;
  const response = yield call(getLanguageMessagesService, languageId);
  if (response.status === 1) {
    const languageMessages = response.results;

    yield put({
      type: actions.CHANGE_LANGUAGE_SUCCESS,
      languageMessages: languageMessages,
      language: language,
    });
  } else if (response.status === 0) {
        DvNotification({
          type: 'error',
          titleId: 'languageSwitcher.switchLanguage',
          messageId: 'error.switchLanguageError',
        });
    yield put({
      type: actions.CHANGE_LANGUAGE_ERROR
    });
  }
}

export function* watchChangeLanguageRequest() {
  yield takeEvery(actions.CHANGE_LANGUAGE_REQUEST, languageMessagesRequest);
}

export default function* rootSaga() {
  yield all([
    fork(watchChangeLanguageRequest),
  ]);
}

